<script>
  import AppContentLoader from '../../components/main/ContentLoader'
  import {Chart} from 'highcharts-vue'
  import exportingInit from 'highcharts/modules/exporting'

  import * as restfulService from '../../services/restfulService'

  import {get, set} from '@utils/storage'

  const isNavigatorOnline = () => navigator.onLine || false

  export default {
    name: 'dashboard-notas-horarios',
    components: {
      AppContentLoader,
      highcharts: Chart
    },
    props: {
      tamanho: {
        default: '75'
      }
    },
    data () {
      return {
        carregandoDados: true,
        contratoAtivo: '',
        contratos: [],
        chartOptions: {
          chart: {
            type: 'bar',
            spacingBottom: 20,
            spacingTop: 10,
            spacingLeft: 10,
            spacingRight: 10
          },
          title: {
            text: ''
          },
          xAxis: {
            categories: ['Avaliações']
          },
          yAxis: {
            min: 0,
            max: 10,
            title: {
              text: ''
            },
            stackLabels: {
              enabled: true,
              formatter: function () {
                return '<br><span align="center">' + this.total + '<br>Média Parcial</span>'
              },
              style: {
                fontWeight: 'bold',
                fontSize: '12px',
                align: 'center',
                color: (Chart.theme && Chart.theme.textColor) || 'black'
              }
            }
          },
          tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat: '{series.name}: {point.y}<br/>Média Geral: {point.stackTotal}'
          },
          legend: {
            title: {
              text: 'Tipos de avaliaçoẽs',
              style: {
                fontSize: '12px',
                fontWeight: 'normal'
              }
            },
            floating: false,
            itemStyle: {
              fontSize: '10px'
            }
          },
          plotOptions: {
            series: {
              stacking: 'normal',
              dataLabels: {
                enabled: true,
                color: (Chart.theme && Chart.theme.dataLabelsColor) || 'white'
              }
            }
          },
          series: []
        }
      }
    },
    computed: {
      listaContratosContagem: function () {
        return this.contratos.length
      },
      todosPossuemMediaFinal () {
        return this.contratos.some(item => item.matriculas.every(obj => obj.media_final))
      },
      possuiMediaFinal () {
        return this.contratos.some(item => item.matriculas.some(obj => obj.media_final))
      },
      possuiExame () {
        return this.contratos.some(item => item.matriculas.some(obj => obj.nota_exame))
      },
      posGraduacao () {
        if (this.contratos.length && this.contratos[0].matriculas.length) {
          return this.contratos[0].matriculas[0].ref_tipo_formacao === 3 ||
            this.contratos[0].matriculas[0].ref_tipo_formacao === 4
        }
        return false
      }
    },
    async mounted () {
      const storage = await get('notasFrequencias')
      if (isNavigatorOnline()) {
        this.buscarMatriculasPeriodoAtivo()
      } else {
        this.contratos = [...(storage || [])]
        this.setaAbaContrato()
        this.carregandoDados = false
      }
    },
    methods: {
      setaAbaContrato () {
        if (this.contratos.length) {
          this.contratoAtivo = 'tab-' + this.contratos[0].id
          this.montaGrafico()
        }
      },
      buscarMatriculasPeriodoAtivo () {
        this.carregandoDados = true
        this.contratos.splice(0)
        restfulService.get('dashboard', 'matriculas')
          .then((response) => {
            if (response.length) {
              set('notasFrequencias', response)
              this.contratos = [...this.contratos, ...response]
              this.setaAbaContrato()
            }
            setTimeout(() => {
              this.carregandoDados = false
            }, 300)
          })
          .catch(e => {
            this.carregandoDados = false
            console.log(e)
          })
      },
      montaGrafico () {
        this.chartOptions.series.splice(0)
        let series = []
        this.contratos.forEach(item => {
          if (item.competencias) {
            item.competencias.avaliacoes.forEach(item2 => {
              let serie = {
                name: item2.desc_tipo_prova + ' (' + item2.peso + ')',
                data: [item2.media]
              }
              series.push(serie)
            })
          }
        })
        this.chartOptions.series = [...series]
        exportingInit(Chart)
      }
    }
  }
</script>

<template>
    <div class="box has-loading" v-bind:class="'box-' + tamanho">
        <app-content-loader :is-loading.sync="carregandoDados"/>
        <div class="box-header">
            <div class="box-title">Notas e Frequências</div>
            <div class="box-nav">
                <div class="box-icon" @click="buscarMatriculasPeriodoAtivo()" title="Recarregar Dados">
                    <i class="fas fa-sync"></i>
                </div>
            </div>
        </div>
        <div class="box-content">
            <div class="box-content-vazio" v-if="listaContratosContagem === 0">
                <div>
                    <div class="icon-vazio"><i class="fas fa-graduation-cap"></i></div>
                    <h3>Você não possui cursos ativos</h3>
                </div>
            </div>
            <div class="box-content-full">
                <v-tabs fixed-tabs
                        slot="extension"
                        v-model="contratoAtivo"
                        v-if="listaContratosContagem > 1"
                        slider-color="orange darken-3">
                    <v-tab v-for="contrato in contratos"
                           :href="`#tab-${contrato.id}`">
                        {{contrato.descricao}}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="contratoAtivo" v-if="listaContratosContagem > 0">
                    <v-tab-item v-for="contrato in contratos"
                                :id="`tab-${contrato.id}`">
                        <div class="notas-lista" >
                            <div class="responsive-table">
                                <div v-if="!contrato.competencias">
                                  <table class="dashboard-table">
                                      <thead>
                                      <tr>
                                          <th :width="posGraduacao ? '80%' : '40%'">Disciplina</th>
                                          <th width="10%">Frequência</th>
                                          <th v-if="posGraduacao" width="10%">Conceito</th>
                                          <th v-if="!posGraduacao" width="10%">Nota 1</th>
                                          <th v-if="!posGraduacao" width="10%">Nota 2</th>
                                          <th v-if="!posGraduacao" width="10%">Nota 3</th>
                                          <th width="10%" v-if="!posGraduacao && !todosPossuemMediaFinal">Média</th>
                                          <th width="10%" v-if="!posGraduacao && possuiExame">Exame</th>
                                          <th width="10%" v-if="!posGraduacao && possuiMediaFinal">Média Final</th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      <tr v-for="item in contrato.matriculas">
                                          <td>{{item.disciplina}}</td>
                                          <td>{{item.frequencias[0].frequencia}}%</td>
                                          <td v-if="posGraduacao">{{item.conceito1 || '-'}}</td>
                                          <td v-if="!posGraduacao">{{item.nota1 || '-'}}</td>
                                          <td v-if="!posGraduacao">{{item.nota2 || '-'}}</td>
                                          <td v-if="!posGraduacao">{{item.nota3 || '-'}}</td>
                                          <td v-if="!posGraduacao && !todosPossuemMediaFinal">{{item.media || '-'}}</td>
                                          <td v-if="!posGraduacao && possuiExame">{{item.nota_exame || '-'}}</td>
                                          <td v-if="!posGraduacao && possuiMediaFinal">{{item.media_final || '-'}}</td>
                                      </tr>
                                      </tbody>
                                  </table>
                                </div>
                                <div v-if="contrato.competencias">
                                  <h3 class="title-tema">{{contrato.competencias.desc_area_tematica}}</h3>
                                  <v-layout row wrap>
                                    <v-flex xs12 sm4>
                                      <table class="dashboard-table modulo">
                                        <thead>
                                          <tr>
                                              <th>Disciplinas Módulo</th>
                                              <th>Frequência</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="disciplina in contrato.competencias.disciplinas">
                                            <td v-if="!disciplina.cpp">{{disciplina.desc_disciplina}}</td>
                                            <td v-if="!disciplina.cpp">{{disciplina.frequencias[0].frequencia}}%</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </v-flex>
                                    <v-flex xs12 sm8>
                                      <div v-if="contrato.competencias.avaliacoes.length > 0">
                                        <highcharts :options="chartOptions" class="charts"></highcharts>
                                      </div>
                                      <div v-if="contrato.competencias.avaliacoes.length == 0">
                                        <v-container fluid>
                                          <v-layout align-center justify-center row fill-height column>
                                              <v-flex xs6><strong>Nenhuma nota registrada</strong></v-flex>
                                          </v-layout>
                                      </v-container>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <hr class="hr-notas-frequencias"></hr>
                                  <v-layout row wrap>
                                    <v-flex xs12 my-2>                                     
                                        <div v-for="disciplina in contrato.competencias.disciplinas">
                                          <v-layout row wrap>
                                            <v-flex xs12 sm4>
                                              <span class="text-disciplina" v-if="disciplina.cpp"> <strong>Disciplina CPP:</strong> {{disciplina.desc_disciplina}}</span>
                                            </v-flex>
                                            <v-flex xs12 sm2>
                                              <span class="text-disciplina" v-if="disciplina.cpp"><strong>Frequência:</strong> {{disciplina.frequencias[0].frequencia}}%</span>
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                              <v-layout row wrap>
                                                <v-flex xs12 sm4>
                                                  <span class="text-disciplina" v-if="disciplina.cpp"><strong>Nota 1:</strong> {{disciplina.nota1}}</span>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                  <span class="text-disciplina" v-if="disciplina.cpp"><strong>Nota 2:</strong> {{disciplina.nota2}}</span>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                  <span class="text-disciplina" v-if="disciplina.cpp"><strong>Média:</strong> {{disciplina.media}}</span>
                                                </v-flex>
                                              </v-layout>  
                                            </v-flex>
                                          </v-layout>
                                        </div>
                                    </v-flex>
                                  </v-layout>
                          </div>
                        </div>
                      </div>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </div>
    </div>
</template>

<style>
    .notas-lista {
      /*max-height: 280px;*/
      overflow-x: hidden;
    }
    .charts {
      width: 100%;
      height: 200px; 
      margin: 0 auto;
    }
    .modulo thead tr th, .modulo tbody tr td{
      padding: 5px !important;
    }
    .text-cpp {
      padding-left: 5px;
      color: #8c8c8c;
      text-align: left;
      font-size: 11px;
    }
    .text-disciplina {
      padding-left: 5px;
      font-size: 12px;
      height: 36px;
      letter-spacing: -0.02em;
    }
    .title-tema {
      text-align: center;
      margin-top: 5px;
    }
    .hr-notas-frequencias {
      border: 1px solid rgba(0, 0, 0, 0.12);
    }
</style>



// WEBPACK FOOTER //
// NotasFrequencias.vue?92050f4c